import { useEffect, useState } from "react";
import api from "@/lib/api";
import { fmtL, fmtDate } from "@/lib/format";

/**
 * 3.14 — Trazabilidad NC ↔ documento afectado.
 * tipo: "factura" | "nota_debito"; docId: id del documento.
 * currentId: NC a resaltar (la que se está viendo).
 */
export default function CNTraceability({ tipo, docId, currentId, title }) {
  const [data, setData] = useState(null);

  useEffect(() => {
    if (!docId) return;
    const url = tipo === "nota_debito" ? `/debit-notes/${docId}/credit-notes` : `/invoices/${docId}/credit-notes`;
    api.get(url).then(({ data }) => setData(data)).catch(() => setData(null));
  }, [tipo, docId]);

  if (!data) return null;
  const d = data.documento || {};
  return (
    <div className="bg-app border border-border rounded-md p-3 mb-4 text-xs" data-testid="cn-trace">
      <div className="text-[10px] uppercase tracking-wider text-agro-green font-semibold mb-2">
        {title || "Notas de crédito aplicadas al documento"}
      </div>
      <div className="grid grid-cols-4 gap-3 mb-2">
        <div><div className="text-text-muted text-[10px] uppercase">Documento</div>
          <div>{tipo === "nota_debito" ? "Nota de Débito" : "Factura"} <span className="font-mono text-agro-green">{d.numero}</span></div></div>
        <div><div className="text-text-muted text-[10px] uppercase">Fecha de emisión</div><div>{fmtDate(d.fecha_emision)}</div></div>
        <div><div className="text-text-muted text-[10px] uppercase">Total</div><div>{fmtL(d.total)}</div></div>
        <div><div className="text-text-muted text-[10px] uppercase">Saldo pendiente</div><div className="text-agro-yellow">{fmtL(d.saldo_pendiente)}</div></div>
      </div>
      {(data.notas_credito || []).length === 0 ? (
        <div className="text-text-muted">Sin notas de crédito aplicadas.</div>
      ) : (
        <table className="w-full">
          <thead><tr className="text-left text-[10px] uppercase text-text-muted border-b border-border">
            <th className="py-1">NC</th><th className="py-1">Fecha</th><th className="py-1">Tipo</th>
            <th className="py-1 text-right">Total</th><th className="py-1 pl-3">Estado</th>
          </tr></thead>
          <tbody>
            {data.notas_credito.map((c) => (
              <tr key={c.id} className={`border-b border-border/30 ${c.estado === "anulada" ? "opacity-50" : ""} ${c.id === currentId ? "text-agro-yellow" : ""}`}>
                <td className="py-1 font-mono">{c.numero}</td>
                <td className="py-1">{fmtDate(c.fecha)}</td>
                <td className="py-1 capitalize">{c.tipo}</td>
                <td className="py-1 text-right">{fmtL(c.total)}</td>
                <td className="py-1 pl-3 uppercase text-[10px]">{c.estado}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
      <div className="text-right text-text-secondary mt-1">Total aplicado: <span className="font-medium">{fmtL(data.total_aplicado)}</span></div>
    </div>
  );
}
